// extracted by mini-css-extract-plugin
export default {"copyContainer":"CopyButton_copyContainer__OLdGv","copiedMessage":"CopyButton_copiedMessage__duzof","clicked":"CopyButton_clicked__7NgwC"};